import { render, staticRenderFns } from "./TextRecommendationCardModal.vue?vue&type=template&id=0c615d6c&scoped=true"
import script from "./TextRecommendationCardModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextRecommendationCardModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TextRecommendationCardModal.vue?vue&type=style&index=0&id=0c615d6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c615d6c",
  null
  
)

export default component.exports